import Column from '../../../Pdf/components/Column';
import Typography from '../../../Pdf/components/Typography';
import theme from '../../../Pdf/components/theme';
import NoPaymentRequired from './NoPaymentRequired';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { CalendarDay } from '../../../../utils';
import { type PaymentDetails } from 'further-types/lp/capital-action-notice';
import PaymentDetailsComponent from './PaymentDetails';
import Card from '../../../Pdf/components/Card';
import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(theme.spacingSizes.sm),
    height: '100%',
  },
});

type Props = {
  firmDomain: string;
  currencyLcy: CurrencyCode;
  dueDate: CalendarDay;
  paymentRequired: boolean;
  paymentDetails: PaymentDetails;
};

const PaymentDetailsSection = ({
  firmDomain,
  currencyLcy,
  dueDate,
  paymentRequired,
  paymentDetails,
}: Props) => {
  return (
    <Card style={styles.card} fullWidth variant="solid">
      <Column spacing="xs" fullWidth>
        <Typography variant="h6">Payment details</Typography>
        {paymentRequired ? (
          <Typography variant="body2" subtle>
            Please make sure the payment is made in {currencyLcy} by{' '}
            {dueDate.toReadable()} or late payment interest may be charged.
            Please also include your payment reference.
          </Typography>
        ) : null}
      </Column>
      {paymentRequired ? (
        <PaymentDetailsComponent {...paymentDetails} />
      ) : (
        <NoPaymentRequired
          investorAccountNumber={paymentDetails.payer.investorAccountNumber}
          firmDomain={firmDomain}
        />
      )}
    </Card>
  );
};

export default PaymentDetailsSection;
